































































import { Component, Prop, Vue } from "vue-property-decorator";
import { DataOptions } from "vuetify/types";
import { ContractsService } from "@/services/api/contracts.service";
import { ContractsModule } from "@/store/contracts.module";
import { BaseModule } from "@/store/base.module";
import moment from "moment";
import { formatDecimal2 } from "@/utils";

@Component({
  watch: {
    from: "getItems",
    to: "getItems",
    options: "getItems",
  },
})
export default class PaymentsItem extends Vue {
  @Prop({ required: true })
  label: string;

  @Prop({ default: null })
  from: string;

  @Prop({ default: null })
  to: string;

  get title() {
    const temp = this.$t("paymentsInfo." + this.label) as string;
    if (
      !this.$vuetify.breakpoint.smAndUp &&
      this.label === "serv_electricity"
    ) {
      return temp.replace("(", "<br />(");
    }
    return temp;
  }

  private makeHeader(
    value: string,
    namespace = "headers",
    align = "right",
    translation = "",
  ) {
    return {
      text: this.$t("paymentsInfo." + namespace + "." + (translation || value)),
      value,
      align,
      width: "1%",
    };
  }
  private makeElectricityHeader(value: string) {
    return this.makeHeader(value, "headers-electricity", "right");
  }
  get headers() {
    if (this.label == "calcs") {
      return [
        this.makeHeader("date_pay", "headers-calc", "left"),
        this.makeHeader("sum_pay", "headers-calc", "right"),
      ];
    }

    const headers = [
      this.makeHeader("period", "headers", "left"),
      this.makeHeader("sum_in"),
    ];
    if (this.label == "serv_electricity") {
      headers.push(
        this.makeElectricityHeader("count_calc"),
        this.makeElectricityHeader("sum_calc_no_nds"),
        this.makeElectricityHeader("sum_nds"),
        this.makeElectricityHeader("avg_tariff"),
      );
    } else if (this.label == "serv_reconnect") {
      headers.push(
        this.makeHeader(
          "sum_calc_no_nds",
          "headers-reconnect",
          undefined,
          "sum_calc",
        ),
      );
    } else {
      headers.push(
        this.makeHeader("sum_calc_no_nds", undefined, undefined, "sum_calc"),
      );
    }
    return [...headers, this.makeHeader("sum_pay"), this.makeHeader("sum_out")];
  }

  items: IPayments[] = [];
  options: DataOptions | null = null;

  get itemsLength() {
    if (!this.items.length) return 0;
    return this.items[0].row_count;
  }
  get parsedItems() {
    return this.items.map(item => ({
      ...item,
      period: moment(item.date_calc_begin, "YYYY-MM-DD").format("MM.YYYY"),
      date_pay: moment(item.date_pay, "YYYY-MM-DD").format("DD.MM.YYYY"),
      sum_in: formatDecimal2(item.sum_in),
      sum_calc: formatDecimal2(item.sum_calc),
      count_calc: item.count_calc,
      sum_calc_no_nds:
        this.label == "serv_reconnect"
          ? formatDecimal2(item.sum_calc_no_nds + item.sum_nds)
          : formatDecimal2(item.sum_calc_no_nds),
      sum_nds: formatDecimal2(item.sum_nds),
      avg_tariff: formatDecimal2(item.avg_tariff),
      sum_pay: formatDecimal2(item.sum_pay),
      sum_out: formatDecimal2(item.sum_out),
    }));
  }
  private async getItems() {
    if (!this.from || !this.to) return;
    BaseModule.setLoadingStatus(true);
    const options = {
      contractId: ContractsModule.selectedContract + "",
      dateBegin: this.from,
      dateEnd: this.to,
      codeName: this.label,
      page: this.options?.page || 1,
      itemsPerPage: this.options?.itemsPerPage || 10,
    };
    if (this.label == "calcs") {
      this.items = await ContractsService.getPaymentsInfo(options);
    } else {
      this.items = await ContractsService.getPayments(options);
    }
    BaseModule.setLoadingStatus(false);
  }

  get sum() {
    const item = this.items[0] || {};
    if (this.label == "serv_electricity" || this.label == "serv_reconnect") {
      return item.sum_calc_no_nds_total + item.sum_nds_total || 0;
    } else if (this.label == "calcs") {
      return item.sum_pay_total || 0;
    }
    return item.sum_calc_no_nds_total || 0;
  }

  get summary() {
    const item = this.items[0] || {};
    return {
      period: this.$t("summary"),
      date_pay: this.$t("summary"),
      sum_pay: formatDecimal2(item.sum_pay_total) || 0,
      count_calc: item.count_calc_total || 0,
      sum_calc: formatDecimal2(item.sum_calc_total) || 0,
      sum_calc_no_nds:
        this.label == "serv_reconnect"
          ? formatDecimal2(this.sum)
          : formatDecimal2(item.sum_calc_no_nds_total) || 0,
      sum_nds: formatDecimal2(item.sum_nds_total) || 0,
    };
  }
}
